// extracted by mini-css-extract-plugin
export default {"loading":"styles_loading__aurD7","loading-animation":"styles_loading-animation__RjPjQ"};